import React,{useEffect} from 'react'
import { useParams , useNavigate } from 'react-router';
import { CircularProgress } from '@mui/material';



function ChatBotInitPage() {

    let { portalId } = useParams();
    const navigate = useNavigate();

    const setAppPortal = async (portal) =>{
        localStorage.setItem("portalUrl",portal.url);
        localStorage.setItem("portalTitle",portal.title);
        localStorage.setItem("portalId",portal.portalId);
        window.location.reload();
    }


    

    const setPortal = (portalId) =>{
        let _portalDetails = null;
        if(portalId == "local-demo1"){
            _portalDetails = {url:"http://localhost:8008",portalId:"local-demo1",title:"Local Demo1 @ 8008"}
        }
        if(portalId == "local-demo2"){
            _portalDetails = {url:"http://localhost:8008",portalId:"local-demo2",title:"Local Demo2 @ 8008"}
        }
        if(portalId == "global-demo1"){
            _portalDetails = {url:"https://whatsapp-api.globalinc.co.in",portalId:"global-demo1",title:"EPF Demo"}
        }

        if(portalId == "global-demo2"){
            _portalDetails = {url:"https://whatsapp-api.globalinc.co.in",portalId:"global-demo2",title:"Nagar Nigam Demo"}
        }
        setAppPortal(_portalDetails);
    }


    const getPortal =() =>{
        if(portalId != localStorage.portalId){
            setPortal(portalId);
        } else {
            if(localStorage.portalUrl != undefined) {
                navigate("/chatbot")
            }
        }
    }
    useEffect(()=>{
        getPortal()
    },[])



    
    return (
        <div className="container">
            <div className="row mt-5">
                <div className='col-md-12 text-center'>
                    <img src='/images/gtoken-logo.jpg' style={{width:"30%"}} />
                </div>
                <div className="col-md-12 text-center">
                    <CircularProgress/>
                </div>
            </div>
        </div>


    )
}

export default ChatBotInitPage